import _definePage_default_0 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/[...404].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_3 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/category.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/editor-new.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/form-design.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/customer-service/index.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/dealer/index.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/event-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/event-management/editor-new.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/file-managers.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/home.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lacquer-worker-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lacquer-worker-management/log/index.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/login/login.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/logoutReload.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lucky-draw/index.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lucky-draw/start_[[id]].vue?definePage&vue&lang.tsx'
import _definePage_default_18 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/notification-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/order-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/points-mall/index.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/points-red-envelope/index.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/index.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/activity-management.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/type.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/qr-code-configuration/index.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/qr-code-configuration/anti-theft-brush.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/referrals-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/referrals-management/configure.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/statistics/index.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/amount-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_31 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/basic-information-management/index.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/key-configuration/index.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/log/index.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/manage.vue?definePage&vue&lang.tsx'
import _definePage_default_35 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/role/index.vue?definePage&vue&lang.tsx'
import _definePage_default_36 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/user/index.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from 'H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/user-center/user-center.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:404(.*)',
    name: '/[...404]',
    component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/[...404].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/article-management',
    /* internal name: '/article-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/article-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/index.vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'category',
        name: '/article-management/category',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/category.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'editor-new',
        name: '/article-management/editor-new',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/editor-new.vue'),
        /* no children */
      },
  _definePage_default_4
  ),
  _mergeRouteRecord(
      {
        path: 'form-design',
        name: '/article-management/form-design',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/article-management/form-design.vue'),
        /* no children */
      },
  _definePage_default_5
  )
    ],
  },
  {
    path: '/customer-service',
    /* internal name: '/customer-service' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/customer-service/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/customer-service/index.vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  {
    path: '/dealer',
    /* internal name: '/dealer' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/dealer/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/dealer/index.vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  {
    path: '/event-management',
    /* internal name: '/event-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/event-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/event-management/index.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'editor-new',
        name: '/event-management/editor-new',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/event-management/editor-new.vue'),
        /* no children */
      },
  _definePage_default_9
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/file-managers',
    name: '/file-managers',
    component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/file-managers.vue'),
    /* no children */
  },
  _definePage_default_10
  ),
  _mergeRouteRecord(
  {
    path: '/home',
    name: '/home',
    component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/home.vue'),
    /* no children */
  },
  _definePage_default_11
  ),
  {
    path: '/lacquer-worker-management',
    /* internal name: '/lacquer-worker-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/lacquer-worker-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lacquer-worker-management/index.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
      {
        path: 'log',
        /* internal name: '/lacquer-worker-management/log' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/lacquer-worker-management/log/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lacquer-worker-management/log/index.vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      }
    ],
  },
  {
    path: '/login',
    /* internal name: '/login' */
    /* no component */
    children: [
      {
        path: '',
        name: '/login/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/login/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'login',
        name: '/login/login',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/login/login.vue'),
        /* no children */
      },
  _definePage_default_14
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/logoutReload',
    name: '/logoutReload',
    component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/logoutReload.vue'),
    /* no children */
  },
  _definePage_default_15
  ),
  {
    path: '/lucky-draw',
    /* internal name: '/lucky-draw' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/lucky-draw/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lucky-draw/index.vue'),
        /* no children */
      },
  _definePage_default_16
  ),
  _mergeRouteRecord(
      {
        path: 'start_:id?',
        name: '/lucky-draw/start_[[id]]',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/lucky-draw/start_[[id]].vue'),
        /* no children */
      },
  _definePage_default_17
  )
    ],
  },
  {
    path: '/notification-management',
    /* internal name: '/notification-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/notification-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/notification-management/index.vue'),
        /* no children */
      },
  _definePage_default_18
  )
    ],
  },
  {
    path: '/order-management',
    /* internal name: '/order-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/order-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/order-management/index.vue'),
        /* no children */
      },
  _definePage_default_19
  )
    ],
  },
  {
    path: '/points-mall',
    /* internal name: '/points-mall' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/points-mall/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/points-mall/index.vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  {
    path: '/points-red-envelope',
    /* internal name: '/points-red-envelope' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/points-red-envelope/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/points-red-envelope/index.vue'),
        /* no children */
      },
  _definePage_default_21
  )
    ],
  },
  {
    path: '/product-manager',
    /* internal name: '/product-manager' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/product-manager/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/index.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
  _mergeRouteRecord(
      {
        path: 'activity-management',
        name: '/product-manager/activity-management',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/activity-management.vue'),
        /* no children */
      },
  _definePage_default_23
  ),
  _mergeRouteRecord(
      {
        path: 'type',
        name: '/product-manager/type',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/product-manager/type.vue'),
        /* no children */
      },
  _definePage_default_24
  )
    ],
  },
  {
    path: '/qr-code-configuration',
    /* internal name: '/qr-code-configuration' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/qr-code-configuration/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/qr-code-configuration/index.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'anti-theft-brush',
        name: '/qr-code-configuration/anti-theft-brush',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/qr-code-configuration/anti-theft-brush.vue'),
        /* no children */
      },
  _definePage_default_26
  )
    ],
  },
  {
    path: '/referrals-management',
    /* internal name: '/referrals-management' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/referrals-management/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/referrals-management/index.vue'),
        /* no children */
      },
  _definePage_default_27
  ),
  _mergeRouteRecord(
      {
        path: 'configure',
        name: '/referrals-management/configure',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/referrals-management/configure.vue'),
        /* no children */
      },
  _definePage_default_28
  )
    ],
  },
  {
    path: '/statistics',
    /* internal name: '/statistics' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/statistics/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/statistics/index.vue'),
        /* no children */
      },
  _definePage_default_29
  )
    ],
  },
  {
    path: '/system-manage',
    /* internal name: '/system-manage' */
    /* no component */
    children: [
      {
        path: 'amount-management',
        /* internal name: '/system-manage/amount-management' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/amount-management/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/amount-management/index.vue'),
            /* no children */
          },
  _definePage_default_30
  )
        ],
      },
      {
        path: 'basic-information-management',
        /* internal name: '/system-manage/basic-information-management' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/basic-information-management/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/basic-information-management/index.vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      },
      {
        path: 'key-configuration',
        /* internal name: '/system-manage/key-configuration' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/key-configuration/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/key-configuration/index.vue'),
            /* no children */
          },
  _definePage_default_32
  )
        ],
      },
      {
        path: 'log',
        /* internal name: '/system-manage/log' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/log/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/log/index.vue'),
            /* no children */
          },
  _definePage_default_33
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'manage',
        name: '/system-manage/manage',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/manage.vue'),
        /* no children */
      },
  _definePage_default_34
  ),
      {
        path: 'role',
        /* internal name: '/system-manage/role' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/role/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/role/index.vue'),
            /* no children */
          },
  _definePage_default_35
  )
        ],
      },
      {
        path: 'user',
        /* internal name: '/system-manage/user' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/system-manage/user/',
            component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/system-manage/user/index.vue'),
            /* no children */
          },
  _definePage_default_36
  )
        ],
      }
    ],
  },
  {
    path: '/user-center',
    /* internal name: '/user-center' */
    /* no component */
    children: [
      {
        path: '',
        name: '/user-center/',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/user-center/index.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'user-center',
        name: '/user-center/user-center',
        component: () => import('H:/1_Project/2024-YuQiJun/YuQiJun.admin/src/views/user-center/user-center.vue'),
        /* no children */
      },
  _definePage_default_37
  )
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

